import { Action, on, createReducer } from '@ngrx/store'
import { CreditStructure } from '../../model/credit-structure.model'
import { CreditGrossLossScenario } from '../../model/credit-portfolio.model'
import { CreditStructureActions } from '../structure/credit-structure.actions'
import { CreditSubmissionStructureActions } from '../submission/credit-submission.actions'
import * as fromCreditEventResultsReducer from './credit-event-results.reducer'
import * as fromCreditAnimatedScenariosActions from './credit-animated-scenarios.actions'
import * as fromCreditActions from '../credit.actions'

export interface State {
  selectedOriginations: CreditGrossLossScenario[]
  selectedActuals: CreditGrossLossScenario[]
  eventResultState: fromCreditEventResultsReducer.ScenarioEventResultState
  executing: boolean
  error: string | null
  selectedStructure: CreditStructure | null
  animating: boolean
  showSlider: boolean
  sliderValue: number
  pendingFetchCount: number
}

export const initialState: State = {
  selectedOriginations: [],
  selectedActuals: [],
  eventResultState: fromCreditEventResultsReducer.initialState,
  executing: false,
  error: null,
  selectedStructure: null,
  animating: false,
  showSlider: false,
  sliderValue: 0,
  pendingFetchCount: 0,
}

const creditAnimatedScenariosReducer = createReducer(
  initialState,
  on(
    fromCreditActions.SetModuleContext,
    CreditStructureActions.resetSelectedStructure,
    CreditSubmissionStructureActions.resetSelectedSubmission,
    () => {
      return {
        ...initialState,
      }
    },
  ),
  on(fromCreditAnimatedScenariosActions.execute, (state, { requests }) => ({
    ...state,
    executing: true,
    animating: true,
    sliderValue: 0,
    pendingFetchCount: requests.length,
  })),
  on(fromCreditAnimatedScenariosActions.setAnimating, (state, { value }) => ({
    ...state,
    animating: value,
  })),
  on(fromCreditAnimatedScenariosActions.executeFailure, (state, { error }) => ({
    ...state,
    executing: false,
    error: error.message,
  })),
  on(fromCreditAnimatedScenariosActions.executeSuccess, (state) => ({
    ...state,
  })),
  on(fromCreditAnimatedScenariosActions.updateOriginations, (state, { grossLossScenarios }) => ({
    ...state,
    selectedOriginations: grossLossScenarios,
  })),
  on(fromCreditAnimatedScenariosActions.updateActuals, (state, { grossLossScenarios }) => ({
    ...state,
    selectedActuals: grossLossScenarios,
  })),
  on(fromCreditAnimatedScenariosActions.clearAnimatedScenariosResults, (state) => ({
    ...state,
    eventResultState: fromCreditEventResultsReducer.initialState,
  })),
  on(fromCreditAnimatedScenariosActions.fetchAnimatedScenariosDataSuccess, (state, action) => {
    const newPendingCount = Math.max(0, state.pendingFetchCount - 1)
    return {
      ...state,
      executing: newPendingCount > 0,
      showSlider: newPendingCount === 0 ? true : state.showSlider,
      pendingFetchCount: newPendingCount,
      eventResultState: fromCreditEventResultsReducer.reducer(state.eventResultState, action),
    }
  }),
  on(fromCreditAnimatedScenariosActions.fetchAnimatedScenariosDataFailure, (state, { error }) => ({
    ...state,
    executing: Math.max(0, state.pendingFetchCount - 1) > 0,
    showSlider:
      Math.max(0, state.pendingFetchCount - 1) === 0 && state.eventResultState.ids.length > 0,
    pendingFetchCount: Math.max(0, state.pendingFetchCount - 1),
    error: error.message,
  })),
  on(fromCreditAnimatedScenariosActions.setSliderValue, (state, { value }) => ({
    ...state,
    sliderValue: value,
  })),
  on(fromCreditAnimatedScenariosActions.addSelectedStructure, (state, { structure }) => ({
    ...state,
    selectedStructure: structure,
  })),

  on(fromCreditAnimatedScenariosActions.resetEventsAndResults, (state) => {
    return { ...initialState, selectedStructure: state.selectedStructure }
  }),
)

export function reducer(state: State | undefined, action: Action) {
  return creditAnimatedScenariosReducer(state, action)
}
